<sa-loading *ngIf="formLoading"></sa-loading>

<div class="outer-container" *ngIf="!formLoading">
  <div class="create-well-form-container">
    <div class="frac-form" *ngIf="displayFracCreation">
      <a
        *ngIf="well && !well.archive && well.id"
        class="back-wrap"
        [routerLink]="['/', 'lmo', 'frac', well.id]"
        (click)="removeLocalStorageSiteCoordinate()"
      >
        <i class="material-icons">arrow_back</i>
        Back to Well
      </a>
      <a
        class="back-wrap"
        [routerLink]="['/', 'wells']"
        *ngIf="well && well.archive"
        (click)="removeLocalStorageSiteCoordinate()"
      >
        <i class="material-icons">arrow_back</i>
        Back to Archived Wells
      </a>
      <a class="back-wrap" [routerLink]="['/', 'lmo']" *ngIf="!well" (click)="removeLocalStorageSiteCoordinate()">
        <i class="material-icons">arrow_back</i>
        Back to Wells
      </a>
      <div style="display: flex;justify-content: center;align-items: center; margin-bottom: 24px;padding-left: 24px;">
        <button
          mat-flat-button
          color="primary"
          *ngIf="wellId && !isLMOCrewLeader()"
          (click)="downloadRecords()"
          style="height: fit-content"
        >
          <span *ngIf="!downloadProgress"
            >Reporting
            <mat-icon style="vertical-align: middle;">vertical_align_bottom</mat-icon>
          </span>
          <mat-spinner class="white-spinner" *ngIf="downloadProgress" [diameter]="20"></mat-spinner>
        </button>
        <h2
          fxLayout="row"
          fxLayoutAlign="start stretch"
          style="flex: 1 1 0; padding-bottom: 0px"
          [ngClass]="{ 'center-text': wellId }"
        >
          <div>
            {{ wellId ? 'Edit Well ' + wellCreationForm.get('jobName').value : 'Create Well' }}
            <span class="api-pill" *ngIf="well?.createdByAPI">API</span>
          </div>
        </h2>

        <button
          mat-flat-button
          color="primary"
          *ngIf="wellId"
          color="{{ this.well.archive ? 'primary' : 'warn' }}"
          (click)="changeWellStatus()"
          style="height: fit-content;color:white;"
        >
          <ng-container *saAllowedAccountRoles="['admin', 'dispatcher']">
            {{ this.well.archive ? 'Reactivate' : 'Archive' }}
          </ng-container>
          <ng-container *saAllowedAccountRoles="['default']">
            <ng-container *ngIf="this.well.archive">
              Reactivate
            </ng-container>
            <ng-container *ngIf="!this.well.archive && (isEligibleToArchive$ | async)">
              Archive
            </ng-container>
          </ng-container>
        </button>
      </div>
      <form
        autocomplete="off"
        *ngIf="wellCreationForm"
        [formGroup]="wellCreationForm"
        (submit)="validateFracInput(true)"
        class="flex flex-col gap-2"
      >
        <!-- Details -->
        <mat-card>
          <mat-card-header><h3>Details</h3></mat-card-header>
          <mat-card-content class="grid grid-cols-2 gap-x-1">
            <div class="grid grid-cols-2 gap-1 w-full">
              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Site Name
                </div>
                <mat-form-field appearance="outline">
                  <input matInput type="text" [formControl]="wellCreationForm.controls['name']" />
                  <mat-error *ngIf="wellCreationForm.controls['name'].hasError('required')">
                    Site Name is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Crew
                </div>
                <mat-form-field appearance="outline">
                  <mat-select formControlName="crewId">
                    <mat-optgroup *ngFor="let groupCrew of crews$ | async" [label]="groupCrew.accountName">
                      <mat-option *ngFor="let crew of groupCrew.crews" [value]="crew.id">{{ crew.name }}</mat-option>
                    </mat-optgroup>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Job Name
                </div>
                <mat-form-field appearance="outline">
                  <input matInput type="text" [formControl]="wellCreationForm.get('jobName')" />
                  <mat-error *ngIf="wellCreationForm.get('name').hasError('required')">
                    Job Name is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Billing Identifier
                  <mat-icon matTooltip="The billing identifier can be the internal identifier for this location."
                    >help</mat-icon
                  >
                </div>
                <mat-form-field appearance="outline">
                  <input matInput type="text" [formControl]="wellCreationForm.controls['billingIdentifier']" />
                </mat-form-field>
              </div>

              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Custom Job ID (Optional)
                </div>
                <mat-form-field appearance="outline">
                  <input matInput type="text" [formControl]="wellCreationForm.get('customJobId')" />
                </mat-form-field>
              </div>

              <div><!-- grid spacer --></div>

              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Offload Capacity
                  <mat-icon matTooltip="The number of trucks which that be offloaded at one time.">help</mat-icon>
                </div>
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="number"
                    autocomplete="off"
                    [formControl]="wellCreationForm.controls['maxTrucks']"
                    [value]="wellCreationForm.controls['maxTrucks'].value"
                  />
                  <mat-error *ngIf="wellCreationForm.controls['maxTrucks'].hasError('required')">
                    Input is required
                  </mat-error>
                  <mat-error
                    *ngIf="
                      wellCreationForm.controls['maxTrucks'].invalid &&
                      !wellCreationForm.controls['maxTrucks'].hasError('required')
                    "
                  >
                    Value can not be less than 1
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Total Number of Stages
                </div>
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="number"
                    autocomplete="off"
                    [formControl]="wellCreationForm.controls['numOfStages']"
                    [value]="wellCreationForm.controls['numOfStages'].value"
                    (blur)="onStageChange()"
                  />
                  <mat-error *ngIf="wellCreationForm.controls['numOfStages'].hasError('required')">
                    Input is required
                  </mat-error>
                  <mat-error
                    *ngIf="
                      wellCreationForm.controls['numOfStages'].invalid &&
                      !wellCreationForm.controls['numOfStages'].hasError('required')
                    "
                  >
                    Value must be greater than 0
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Prefill Date
                </div>
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    class="datepicker-input"
                    autocomplete="off"
                    [formControl]="wellCreationForm.controls['prefillDate']"
                    [owlDateTime]="dt2"
                    [owlDateTimeTrigger]="dt2"
                  />
                  <span [owlDateTimeTrigger]="dt2"><i class="material-icons">calendar_today</i></span>
                  <owl-date-time #dt2></owl-date-time>
                  <!--<mat-datepicker-toggle matSuffix [for]="prefillPicker"></mat-datepicker-toggle>-->
                  <!--<mat-datepicker #prefillPicker></mat-datepicker>-->
                  <mat-error *ngIf="wellCreationForm.controls['prefillDate'].hasError('required')">
                    Input is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Frac Date
                </div>
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    class="datepicker-input"
                    autocomplete="off"
                    [formControl]="wellCreationForm.controls['fracDate']"
                    [owlDateTime]="dt3"
                    [owlDateTimeTrigger]="dt3"
                  />
                  <span [owlDateTimeTrigger]="dt3"><i class="material-icons">calendar_today</i></span>
                  <owl-date-time #dt3></owl-date-time>
                  <mat-error *ngIf="wellCreationForm.controls['fracDate'].hasError('required')">
                    Input is required
                  </mat-error>
                  <mat-error
                    *ngIf="
                      wellCreationForm.controls['fracDate'].hasError('older') &&
                      !wellCreationForm.controls['fracDate'].hasError('required')
                    "
                  >
                    Frac Date can not be older than Prefill Date
                  </mat-error>
                </mat-form-field>
              </div>

              <ng-container *ngIf="districtList?.length">
                <div class="flex flex-col form-field">
                  <div class="form-field-label">
                    District
                  </div>
                  <mat-form-field appearance="outline">
                    <mat-select [formControl]="wellCreationForm.controls['district']" [compareWith]="compareFn">
                      <mat-option *ngFor="let district of districtList" [value]="district">
                        <span>{{ district.name }}</span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </ng-container>

              <ng-container *saFeatureFlag="'fracBasedFuelSurcharge'">
                <div class="flex flex-col justify-center px-2">
                  <mat-slide-toggle
                    color="primary"
                    [formControl]="wellCreationForm.get('enableFuelSurcharge')"
                    [disabled]="!billingSettings.addFuelSurcharge"
                    >Enable Fuel Surcharge</mat-slide-toggle
                  >
                  <ng-container *ngIf="billingSettings.addFuelSurcharge; else fscSettingsDisabled">
                    <mat-hint>If turned on, fuel surcharge will be applied to loads</mat-hint>
                  </ng-container>
                  <ng-template #fscSettingsDisabled>
                    <mat-hint>Enable Fuel Surcharge in Billing Settings to use this feature</mat-hint>
                  </ng-template>
                </div>
              </ng-container>

              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Required Certifications
                </div>
                <mat-form-field appearance="outline">
                  <mat-select formControlName="driverCertifications" multiple [compareWith]="compareByValue">
                    <mat-option *ngFor="let dc of driverCertifications" [value]="dc">{{ dc.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  {{ requireFracTrailerTypes ? 'Required Trailer Types *' : 'Required Trailer Types' }}
                </div>
                <mat-form-field appearance="outline">
                  <mat-select formControlName="trailerTypes" multiple [compareWith]="compareByValue">
                    <mat-option *ngFor="let tt of trailerTypes" [value]="tt">{{ tt.name }}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="requireFracTrailerTypes && wellCreationForm.controls['trailerTypes'].hasError('required')"
                  >
                    At least one trailer type is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-span-2 flex flex-col form-field">
                <div class="form-field-label">
                  Subscribed Users
                  <mat-icon
                    matTooltip="Select which [Standard] users should have access to this well. [Admin] users have access to all wells by default."
                    >help</mat-icon
                  >
                </div>
                <mat-form-field appearance="outline">
                  <mat-select
                    [formControl]="wellCreationForm.controls['allowedUsers']"
                    [compareWith]="compareByTypeAndId"
                    multiple
                  >
                    <mat-select-trigger>
                      <mat-chip-list>
                        <mat-chip
                          *ngFor="
                            let user of wellCreationForm.controls['allowedUsers'].value;
                            trackBy: trackById;
                            let i = index
                          "
                          class="subscribed-user-chip"
                        >
                          {{ user.name }}</mat-chip
                        >
                      </mat-chip-list>
                    </mat-select-trigger>
                    <mat-option>
                      <ngx-mat-select-search
                        [placeholderLabel]="'Subscribed Users'"
                        [noEntriesFoundLabel]="'No User found'"
                        [formControl]="filterUser"
                      ></ngx-mat-select-search>
                    </mat-option>
                    <mat-optgroup *ngFor="let groupType of filteredUserOptions | async" [label]="groupType.type">
                      <mat-option *ngFor="let user of groupType.users" [value]="user" (click)="userSelected(user)">
                        {{ user.name }}
                      </mat-option>
                    </mat-optgroup>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-span-2 flex flex-col form-field">
                <div class="form-field-label">
                  Health, Safety and Environment (HSE) Requirements
                </div>
                <mat-form-field appearance="outline">
                  <textarea
                    matInput
                    maxlength="5000"
                    matAutosizeMinRows="5"
                    matAutosizeMaxRows="10"
                    matTextareaAutosize
                    [formControl]="wellCreationForm.controls['hseRequirements']"
                  >
                  </textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Location -->
        <mat-card *ngIf="!isStandardUser">
          <mat-card-header>
            <h3>Location</h3>
          </mat-card-header>

          <mat-card-content class="p-2">
            <sa-frac-creation-map
              [site]="this.well && this.well.site"
              style="height:700px; display:block;"
            ></sa-frac-creation-map>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header>
            <h3>GPS Direction Location</h3>
          </mat-card-header>
          <mat-card-subtitle>
            Use where the lease road begins. This location is provided to drivers for their use in getting directions
            from 3rd party applications.
          </mat-card-subtitle>
          <mat-card-content class="grid grid-cols-2 gap-2">
            <div class="grid grid-cols-2 gap-x-2">
              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Latitude
                </div>
                <mat-form-field appearance="outline">
                  <input matInput type="number" [formControl]="wellCreationForm.controls['gpsDirectionLocationLat']" />
                  <mat-error *ngIf="wellCreationForm.controls['gpsDirectionLocationLat'].hasError('required')">
                    Input is required
                  </mat-error>
                  <mat-error
                    *ngIf="
                      wellCreationForm.controls['gpsDirectionLocationLat'].hasError('latitude') &&
                      !wellCreationForm.controls['gpsDirectionLocationLat'].hasError('required')
                    "
                  >
                    Latitude value should be between -90 and 90
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col form-field">
                <div class="form-field-label">
                  Longitude
                </div>
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    placeholder="Longitude"
                    type="number"
                    [formControl]="wellCreationForm.controls['gpsDirectionLocationLng']"
                  />
                  <mat-error *ngIf="wellCreationForm.controls['gpsDirectionLocationLng'].hasError('required')">
                    Input is required
                  </mat-error>
                  <mat-error
                    *ngIf="
                      wellCreationForm.controls['gpsDirectionLocationLng'].hasError('longitude') &&
                      !wellCreationForm.controls['gpsDirectionLocationLng'].hasError('required')
                    "
                  >
                    Longitude value should be between -180 and 180
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-span-2" id="map-gps-direction-location"></div>

              <div class="flex flex-col form-field col-span-2">
                <div class="form-field-label">
                  Directions to Well
                </div>
                <mat-form-field appearance="outline">
                  <textarea
                    matInput
                    placeholder="Directions to Well"
                    maxlength="5000"
                    matAutosizeMinRows="5"
                    matAutosizeMaxRows="10"
                    matTextareaAutosize
                    [formControl]="wellCreationForm.controls['direction']"
                  >
                  </textarea>
                  <mat-hint align="end">{{ wellCreationForm.controls['direction'].value?.length || 0 }}/5000</mat-hint>
                </mat-form-field>
              </div>

              <div class="flex flex-col form-field col-span-2">
                <div class="form-field-label">
                  Entrance Speed Limit (MPH)
                </div>
                <mat-form-field appearance="outline">
                  <input type="number" matInput [formControl]="wellCreationForm.controls['entranceSpeed']" />
                  <mat-error *ngIf="wellCreationForm.controls['entranceSpeed'].hasError('min')">
                    Speed limit must be greater than 0 MPH
                  </mat-error>
                  <mat-error *ngIf="wellCreationForm.controls['entranceSpeed'].hasError('max')">
                    Speed limit must be no greater than 85 MPH
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="!isStandardUser">
          <mat-card-header><h3>Storages</h3></mat-card-header>
          <mat-card-subtitle *ngIf="!well || !well.id">
            Add storages with mesh types that the well will be using
          </mat-card-subtitle>
          <mat-card-content>
            <div class="px-2">
              <button
                type="button"
                mat-flat-button
                color="primary"
                *ngIf="canEdit && !well?.createdByAPI"
                (click)="openStorageForm(null)"
              >
                Add New
              </button>
            </div>
            <div class="grid grid-cols-2 gap-1 p-2">
              <mat-card *ngFor="let storage of wellCreationForm.controls['storages'].value; let i = index">
                <mat-card-header>
                  <h3>{{ storage.name }}</h3>
                </mat-card-header>
                <mat-card-subtitle> {{ storage.mesh.type }} Mesh </mat-card-subtitle>
                <mat-card-content>
                  <div>
                    Capacity <span class="font-bold">{{ numberWithCommas(storage.capacity) }} lbs</span>
                  </div>
                  <div>
                    Load weight <span class="font-bold">{{ numberWithCommas(storage.loadWeight) }} lbs</span>
                  </div>
                </mat-card-content>
                <mat-card-actions>
                  <div class="flex flex-row justify-between">
                    <div class="flex flex-row gap-1">
                      <button
                        mat-flat-button
                        type="button"
                        color="primary"
                        *ngIf="canEdit"
                        (click)="openStorageForm(storage)"
                      >
                        Edit
                      </button>
                      <ng-container *saFeatureFlag="'manageSupplementalMeshes'">
                        <div
                          [matTooltip]="'Save storage before adding supplemental meshes'"
                          [matTooltipDisabled]="storage.updatedAt"
                        >
                          <button
                            mat-flat-button
                            type="button"
                            color="primary"
                            [disabled]="!storage.updatedAt"
                            *ngIf="canEdit"
                            (click)="openStorageSupplementalMeshForm(storage)"
                          >
                            Supplemental Meshes
                          </button>
                        </div>
                      </ng-container>
                    </div>
                    <div>
                      <button
                        mat-flat-button
                        type="button"
                        color="warn"
                        *ngIf="canEdit && !well?.createdByAPI"
                        (click)="removeStorage(i)"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </mat-card-actions>
              </mat-card>
            </div>
          </mat-card-content>
        </mat-card>

        <div fxLayout="row" fxLayoutAlign="flex-end" class="action-buttons" style="overflow: auto">
          <button mat-flat-button color="primary" type="submit" class="next-btn" [disabled]="isStandardUser">
            Next
          </button>
        </div>
        <br /><br />
      </form>
    </div>

    <div class="schedule-form relative" *ngIf="displayFracSchedule">
      <form
        *ngIf="wellScheduleForm"
        [formGroup]="wellScheduleForm"
        (submit)="validateScheduleInput(true)"
        autocomplete="off"
      >
        <h2 fxLayout="row" fxLayoutAlign="center">Frac Schedule</h2>

        <div #stageGridHeader class="grid items-end headerRow sticky top-0">
          <div class="headerCell stageColumn pr-1">
            Stage
          </div>
          <div *ngFor="let storage of wellCreationForm.controls['storages'].value" class="headerCell inputColumn pr-1">
            {{ storage.mesh.type }} Mesh (lbs)
          </div>
          <div class="headerCell inputColumn pr-1">
            Pump Time (mins)
          </div>
          <div class="headerCell inputColumn pr-1">
            Time Btw. Stages (mins)
          </div>
          <div class="headerCell actionsColumn"><!-- Spacer for menu icon --></div>
        </div>
        <div #stageGridBody class="grid items-center tableRows">
          <ng-container *ngFor="let stage of stages; let i = index">
            <div class="stageColumn py-1 pr-1">
              {{ i + 1 }}
            </div>
            <div
              *ngFor="let storage of wellCreationForm.controls['storages'].value"
              class="tableCell inputColumn py-1 pr-1"
            >
              <input
                type="text"
                sa-number-input
                required
                class="m-0"
                [ngClass]="{
                  'input-error': wellScheduleForm.controls[i + ' ' + storage.mesh.type].invalid && formSubmitted
                }"
                [formControl]="wellScheduleForm.controls[i + ' ' + storage.mesh.type]"
              />
            </div>
            <div class="tableCell inputColumn py-1 pr-1">
              <input
                required
                type="number"
                [ngClass]="{ 'input-error': wellScheduleForm.controls[i + ' pumpTime'].invalid && formSubmitted }"
                [formControl]="wellScheduleForm.controls[i + ' pumpTime']"
                [value]="wellScheduleForm.controls[i + ' pumpTime'].value"
              />
            </div>
            <div class="tableCell inputColumn py-1">
              <input
                required
                type="number"
                [ngClass]="{ 'input-error': wellScheduleForm.controls[i + ' downTime'].invalid && formSubmitted }"
                [formControl]="wellScheduleForm.controls[i + ' downTime']"
                [value]="wellScheduleForm.controls[i + ' downTime'].value"
              />
            </div>
            <div class="actionsColumn py-1">
              <i class="material-icons" [matMenuTriggerFor]="menu">content_copy</i>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="copyIntoNRowsAbove($event)" *ngIf="i > 1">
                  <span *ngIf="!copyNRowsAboveEdit">Copy Into Every Nth Row Above</span>
                  <input
                    *ngIf="copyNRowsAboveEdit"
                    #nRowsEditNum
                    matInput
                    placeholder="Copy Into Every Nth Row Above"
                    type="number"
                    (keyup.enter)="enterCopyNRowsAbove(nRowsEditNum.value, i)"
                  />
                </button>
                <button mat-menu-item (click)="copyIntoPreviousRow(i)" *ngIf="i !== 0">
                  Copy Into Previous
                </button>
                <button mat-menu-item (click)="copyIntoAllPreviousRows(i)" *ngIf="i !== 0">
                  Copy Into All Above
                </button>
                <button mat-menu-item (click)="copyIntoAllRows(i)" *ngIf="i !== 0">
                  Copy Into All
                </button>
                <button mat-menu-item (click)="copyIntoNextRow(i)" *ngIf="i !== stages.length - 1">
                  Copy Into Next
                </button>
                <button mat-menu-item (click)="copyIntoAllNextRows(i)" *ngIf="i !== stages.length - 1">
                  Copy Into All Below
                </button>
                <button mat-menu-item (click)="copyIntoEveryOtherRows(i)" *ngIf="i < stages.length - 2">
                  Copy Into Every Other Below
                </button>
                <button mat-menu-item (click)="copyPumpTimeIntoAllRowsBelow(i)" *ngIf="i < stages.length - 1">
                  Copy Pump Time to All Below
                </button>
                <button mat-menu-item (click)="copyDownTimeIntoAllRowsBelow(i)" *ngIf="i < stages.length - 1">
                  Copy Time Between Stages to All Below
                </button>
                <button mat-menu-item (click)="copyIntoNRowsBelow($event)" *ngIf="i < stages.length - 3">
                  <span *ngIf="!copyNRowsBelowEdit">Copy Into Every Nth Row Below</span>
                  <input
                    *ngIf="copyNRowsBelowEdit"
                    #nRowsEditNum
                    matInput
                    placeholder="Copy Into Every Nth Row Below"
                    type="number"
                    (keyup.enter)="enterCopyNRowsBelow(nRowsEditNum.value, i)"
                  />
                </button>
              </mat-menu>
            </div>
          </ng-container>
          <div class="tableCell py-1">Totals:</div>
          <div
            *ngFor="let storage of wellCreationForm.controls['storages'].value; let i = index"
            class="tableCell py-1 text-lg"
          >
            <span *ngIf="i !== 0">+</span> {{ numberWithCommas(totalVolumesByMesh[storage.mesh.type]) }} lbs
          </div>
          <div class="tableCell text-xl py-1 col-span-3">
            <span>=</span> {{ numberWithCommas(totalVolumesByMesh['totalVolume']) }} lbs
          </div>
        </div>

        <hr />

        <div fxLayout="row" fxLayoutAlign="space-between" class="action-buttons" style="overflow: auto">
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="backFromFracSchedule()"
            [disabled]="submitting"
          >
            Back
          </button>
          <button mat-flat-button color="primary" type="submit" [disabled]="submitting">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
